module.exports = __webpack_public_path__ + "imgs/google.aac72588f6c1b3f12eb1c1555f024f02.svg";